import { API } from "@infra/implementations/api";
import { FileDownloader } from "@infra/implementations/browser/download";
import type { IJobCreation } from "@infra/interfaces/job/IJobCreation";
import type { IAttachmentDownloader } from "@infra/interfaces/browser/IAttachmentDownloader";
import type { Job, Deal, Grower, Contact, Branch, User } from "../../../models";
import { SubmitJobsUseCase } from "@app/job/SubmitJobsUseCase";
import { MissionsUseCase } from "@app/job/MissionsUseCase";

const jobCreationApi: IJobCreation = {
	getGrowersByFilter: (filter) => API.Data.Growers.get.byFilter(filter) as Promise<Grower[]>,
	createGrowers: (growers) => API.Data.Growers.create.many(growers) as Promise<Grower[]>,
	createContacts: (contacts) => API.Data.Contacts.create.many(contacts) as Promise<Contact[]>,
	getContactsByIds: (ids) => API.Data.Contacts.get.byIds(ids) as Promise<Contact[]>,
	getBranchesByIds: (ids) => API.Data.Branches.get.byIds(ids) as Promise<Branch[]>,
	updateContacts: (contacts) => API.Data.Contacts.update.many(contacts) as unknown as Promise<void>,
	updateBranches: (branches) => API.Data.Branches.update.many(branches) as unknown as Promise<void>,
};

const attachmentDownloader: IAttachmentDownloader = {
	load: (attachment, recordId, responseType) => FileDownloader.loadAttachment(attachment, recordId, responseType),
};

export const submitJobsUseCase = new SubmitJobsUseCase({
	jobCreationApi,
	getCurrentUser: () => API.Users.me() as Promise<User>,
	getDealsByIds: (ids) => API.Data.Deals.get.byIds(ids) as Promise<Deal[]>,
	createJobs: (jobs) => API.Data.Jobs.create.many(jobs) as Promise<Job[]>,
});

export const missionsUseCase = new MissionsUseCase({ downloader: attachmentDownloader });
